
const state = {
	status: '',
	token: '',
	user: {}
}

const mutations = {
	auth_request(state) {
		state.status = 'loading'
	},
	auth_success(state, payload) {
		state.status = 'success'
		state.token = payload.token
		state.user = payload.user
	},
	auth_error(state) {
		state.status = 'error'
	},
	logout(state) {
		state.status = '';
		state.token = '';
		state.user = '';
	},
}

const actions = {
	updateUserToken({ commit }, obj) {
		const token = obj.token;
		const user = obj.user;
		commit({
			type: 'auth_success',
			token: token,
			user: user
		});
	}
}

const getters = {
	isLoggedIn: state => !!state.token,
	authStatus: state => state.status,
	currentUser: (state) => {
		if (state.token != null && state.user.uId) {
			return state.user
		} 
		else {
			return {};
		}
	},
	isAdministrator: (state) => {
		return Array.isArray(state.user.roles) &&  state.user.roles.indexOf('Administrator') > -1;
	},
}

export default {
	state,
	mutations,
	actions,
	getters
}
